export let generatedChartColors = {
  genereratedII: '#105567',
  genereratedIII: '#105567',
  active: '#105567'
};



